/**
 * 获取运行环境
 */
export default function getEnv () {
  return new Promise((resolve) => {
    if (window.navigator.userAgent.toLowerCase().includes('micromessenger')) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          //小程序
          resolve('mp')
        } else {
          //微信
          resolve('wechat')
        }
      })
    } else {
      //浏览器
      resolve('browser')
    }
  })
}
